import { useMemo } from "react";
import { BusinessAttributes } from "../types/agent.type";

export function useCustomerAttributes({
  customerAttrs,
  businessAttrs,
  type,
}: {
  customerAttrs: Record<string, any>;
  businessAttrs: BusinessAttributes[];
  type: "call" | "callback" | "voicemail" | "chat" | "detail" | 'case-detail';
}) {
  return useMemo(() => {
    const exclude = new Set<string>();
    let notesPresent = false;
    let notesKey = "";

    if (type === "chat") {
      exclude.add("firstname");
      exclude.add("lastname");
    } else if (type === "case-detail") {
      exclude.add("firstname");
      exclude.add("lastname");
      exclude.add("notes");
      exclude.add("CASE_DESCRIPTION_BASE64".toLowerCase());
      exclude.add("CASE_TITLE".toLowerCase());
      exclude.add("PRODUCTFAMILY".toLowerCase());
      exclude.add("CASEID".toLowerCase());
    } else {
      exclude.add("notes");
    }

    const matched: BusinessAttributes[] = [];
    businessAttrs.forEach((attr) => {
      const name = attr.attributeName.toLowerCase();
      const exists = customerAttrs.hasOwnProperty(attr.attributeName);

      if (!exists || exclude.has(name)) return;

      if (name === "notes") {
        notesPresent = true;
        notesKey = attr.attributeName;
      }

      matched.push(attr);
    });

    const chunkSize = type === "detail" || type === "case-detail" ? 3 : 2;
    const groupedAttributes: BusinessAttributes[][] = [];


    for (let i = 0; i < matched.length; i += chunkSize) {
      groupedAttributes.push(matched.slice(i, i + chunkSize));
    }

    return {
      groupedAttributes,
      notesPresent,
      notesKey,
    };
  }, [customerAttrs, businessAttrs, type]);
}
